import Cookies from 'js-cookie';
import {
  getPreferencesCookieName,
  getDefaultPreferences,
  type PreferencesState,
} from '@/config/preferences';

export function getPreferencesFromCookie(userId?: string): PreferencesState {
  try {
    const cookieName = getPreferencesCookieName(userId);
    const cookieValue = Cookies.get(cookieName);
    if (!cookieValue) {
      return getDefaultPreferences();
    }
    const parsed = JSON.parse(cookieValue);
    // Merge with defaults to ensure all keys exist
    return { ...getDefaultPreferences(), ...parsed };
  } catch {
    return getDefaultPreferences();
  }
}

export function savePreferencesToCookie(
  preferences: PreferencesState,
  userId?: string,
): void {
  const cookieName = getPreferencesCookieName(userId);
  // Save without expiration (session cookie that persists)
  Cookies.set(cookieName, JSON.stringify(preferences), {
    // No expires means the cookie will persist until manually deleted
    // Using a very far future date to simulate "no expiration"
    expires: 365 * 100, // 100 years
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production',
  });
}

export function updatePreference(
  key: string,
  value: boolean | string,
  userId?: string,
): PreferencesState {
  const currentPreferences = getPreferencesFromCookie(userId);
  const updatedPreferences = {
    ...currentPreferences,
    [key]: value,
  };
  savePreferencesToCookie(updatedPreferences, userId);
  return updatedPreferences;
}

export function resetPreferences(userId?: string): PreferencesState {
  const defaults = getDefaultPreferences();
  savePreferencesToCookie(defaults, userId);
  return defaults;
}
